import React from 'react';
import { ShowcaseGallery } from '@/components/showcase';
import { useTitle } from '../../hooks/useTitle';

/**
 * Main showcase gallery page
 */
const ShowcaseGalleryPage: React.FC = () => {
  useTitle('Agent Showcase Gallery');

  return (
    <div className="container py-8">
      <ShowcaseGallery showFeatured={true} />
    </div>
  );
};

export default ShowcaseGalleryPage;